<script>
    import Filters from '../filters'

    export default {
        mixins: [Filters],
        data() {
            return {
                commandProcessing: {
                    uploads: false,
                    db: false,
                    sap: false,
                    neos: false,
                    persistent: false,
                },
                errorMessage: '',
                successMessage: '',
                currentTab: 'mt',
                availableLanguages: [],
                exportGroups: [],
                importRequested: false,
                uploadsStatus: {
                    start: 0,
                    processing: 0,
                    finished: 0,
                },
                dbStatus: {
                    start: 0,
                    processing: 0,
                    finished: 0,
                },
                sapStatus: {
                    start: 0,
                    processing: 0,
                    finished: 0,
                },
                neosStatus: {
                    start: 0,
                    processing: 0,
                    finished: 0,
                },
                persistentStatus: {
                    start: 0,
                    processing: 0,
                    finished: 0,
                },
                massActionStatus: {
                    start: 0,
                    processing: 0,
                    finished: 0,
                },
                cacheStructure: {},
                marketingImport: 0,
                cacheFunctions: [],
                rebuildCachesFiles: [],
                mtCacheLabelMapping: {},
            }
        },

        mounted() {
            this.$store.commit('mainPage', {
                current: this.$t('Admin'),
                stack: [{
                    'path': '/admin',
                    'title': this.$t('Admin'),
                }]
            })
            if (this.isAdmin()) {
                this.fetchData()
                setInterval(this.fetchData, 10000)
            }
        },

        methods: {
            isAdmin() {
                let user = this.$root.Storage.get('user')

                return user && user.roleShortcut === 'admin'
            },
            fetchData() {
                this.$root.fetch('admin', {
                    action: 'getStatus'
                }).then((response) => {
                    if (Array.isArray(response.importStatus)) {
                        this.availableLanguages = response.importStatus
                        this.importRequested = response.importRequested
                        this.cacheStructure = response.cacheStructure
                        this.cacheFunctions = response.cacheFunctions
                        this.mtCacheLabelMapping = response.mtCacheLabelMapping
                        this.rebuildCachesFiles = response.rebuildCachesFiles
                        this.uploadsStatus = response.uploadsStatus
                        this.dbStatus = response.dbStatus
                        this.sapStatus = response.sapStatus
                        this.neosStatus = response.neosStatus
                        this.persistentStatus = response.persistentStatus
                        this.massActionStatus = response.massactionStatus
                        this.marketingImport = response.marketingImport
                        this.exportGroups = response.exportGroups
                    } else {
                        this.errorMessage = response.data
                        setTimeout(this.resetMessage, 4000)
                    }
                })
            },
            resetMessage() {
                this.errorMessage = ''
                this.successMessage = ''
            },
            executeCommand(command) {
                this.resetMessage()
                if (confirm(this.$t('Are you sure you want to do this action?'))) {
                    this.commandProcessing[command] = true
                    this.$root.fetch('command', {
                        command: command,
                    }).then((response) => {
                        this.commandProcessing[command] = false
                        if (response) {
                            this.successMessage = response
                        } else {
                            this.errorMessage = this.$t('Something went wrong. Please contact administrator.')
                        }
                        this.fetchData()
                        setTimeout(this.resetMessage, 4000)
                    })
                }
            },
            changeTab(tabName) {
                this.currentTab = tabName
            },
            view(tab) {
                return this.currentTab === tab
            },
        },
    }
</script>

<template>
    <section class="section">
        <div class="container-fluid">
            <div class="b-tabs" v-if="isAdmin">
                <nav class="tabs is-boxed">
                    <ul>
                        <li :class="{ 'is-active': currentTab === 'mt' }">
                            <a @click="changeTab('mt')"><span>{{ $t('Mapping Tool Project') }}</span></a>
                        </li>
                        <li :class="{ 'is-active': currentTab === 'neos' }">
                            <a @click="changeTab('neos')"><span>{{ $t('NEOS Project') }}</span></a>
                        </li>
                        <li :class="{ 'is-active': currentTab === 'sap' }">
                            <a @click="changeTab('sap')"><span>SAP</span></a>
                        </li>
                        <li :class="{ 'is-active': currentTab === 'mt-file-i18n' }">
                            <a @click="changeTab('mt-file-i18n')"><span>{{ $t('Multi actions') }}</span></a>
                        </li>
                    </ul>
                </nav>

                <section class="tab-content card is-card-table is-card-detail">
                    <div class="tab-item">
                        <article :class="{ 'message': true, 'is-primary': successMessage, 'is-danger': errorMessage }"
                                 v-if="errorMessage || successMessage">
                            <div class="message-body">
                                {{ errorMessage }}{{ successMessage }}
                            </div>
                        </article>

                        <template v-if="view('neos')">
                            <admin-neos :neos-status="neosStatus"
                                        :sap-status="sapStatus"
                                        :persistent-status="persistentStatus"
                                        :uploads-status="uploadsStatus"
                                        :db-status="dbStatus"
                                        :command-processing="commandProcessing"
                                        :cache-structure="cacheStructure"
                                        :cache-functions="cacheFunctions"
                                        :cache-labels="mtCacheLabelMapping"
                                        :rebuild-cache-files="rebuildCachesFiles"
                                        :marketing-import="marketingImport"
                                        @execute="executeCommand" />
                        </template>

                        <template v-if="view('sap')">
                            <admin-sap :available-languages="availableLanguages" :import-requested="importRequested" />
                        </template>

                        <template v-if="view('mt')">
                            <admin-mt :command-processing="commandProcessing"
                                      :neos-status="neosStatus"
                                      :persistent-status="persistentStatus"
                                      :uploads-status="uploadsStatus"
                                      :db-status="dbStatus"
                                      :sap-status="sapStatus"
                                      :import-requested="importRequested"
                                      @execute="executeCommand" />
                        </template>

                        <template v-if="view('mt-file-i18n')">
                            <admin-mass :available-languages="availableLanguages"
                                        :export-groups="exportGroups"
                                        :mass-action-status="massActionStatus" />
                        </template>
                    </div>
                </section>
            </div>

            <template v-if="!isAdmin()">
                {{ $t('You have not enough permissions to see this area') }}
            </template>
        </div>
    </section>
</template>
